import NormalApis from '@/controllers/NormalApis';

export default {
  namespaced: true,
  state: {
    user: {
      token: '',
      id: '',
    },
  },
  getters: {
    token: state => state.user.token,
    username: state => state.user.fname + ' ' + state.user.lname,
    userid: state => state.user.id ? state.user.id : '',
    role: state => state.user.role ? state.user.role : '',
    user: state => state.user,
  },
  mutations: {
    userMutate(state, data) {
      state.user = data;
    },
    userMutateByKey(state, data) {
      // Mutate only if key exist on state
      for(let key in state.user){
        // If key exist in data, push it 
        if(data.hasOwnProperty(key)) {
          state.user[key] = data[key]
        }
      }
    },
    userRedirectMutate(state, data) {
      state.loginRedirect = data;
    },
  },
  actions: {
    async setUser(context, data) {
      let res = await NormalApis.login(data);
      if(res.status && res.status == 200){
        // If success save it.
        context.commit('userMutate', res.data.payload);
      }
      return res;
    },

    async updateUserByKey(context, data) {
      context.commit('userMutateByKey', data);
    },

    async setUserRedirect(context, data) {
      context.commit('userRedirectMutate', data);
    },
  },
};
